export const commitHash = process.env.GITHUB_SHA;
